import Axios from "axios";
import {initPhoneForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initSourcePhonesEdit() {

	const phoneForm = initPhoneForm(document.querySelector('.phone-form'));

	document.querySelector('.update-phone-button').onclick = editPhone;

	// Init copy inputs

	document.querySelectorAll('.copy-on-click').forEach(container => {
		container.addEventListener('click', () => {
			const input = container.querySelector('input');
			navigator.clipboard.writeText(input.value).then(() => {
				alert('URL copied to clipboard')
			});
		})
	});

	/**
	 * Methods
	 */

	function editPhone() {
		const data = phoneForm.inputs();

		phoneForm.clearFeedbacks();

		loading();

		Axios.post(phoneForm.postUrl(), data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initSourcePhonesEdit}
